import { Stack } from "@mui/material";
import { DRDPProvider } from "./context";
import { DRDPDay } from "./day";
import { useDRDP } from "./logics";
import { DRDPMonthYear } from "./monthYear";
import { DRDPContainer, calendarClasses } from "./styles";

export const DRPDay = () => {
  const contextValues = useDRDP();
  return (
    <DRDPContainer className={calendarClasses.root}>
      <DRDPProvider {...contextValues}>
        <Stack
          direction="column"
          sx={{
            width: 252,
            gap: 1,
          }}
        >
          <DRDPMonthYear index="startDate" />
          <DRDPDay index="startDate" />
        </Stack>
        <Stack
          direction="column"
          sx={{
            width: 252,
            gap: 1,
          }}
        >
          <DRDPMonthYear index="endDate" />
          <DRDPDay index="endDate" />
        </Stack>
      </DRDPProvider>
    </DRDPContainer>
  );
};
